module.exports = __webpack_public_path__ + "static/media/realtimetext-bold.3818fd61.woff2";